/* cs-p02-continue.js
 * B3「繼續逛」的前端：去重、相似款式、最近看過（sections/cs-p02-continue.liquid）。
 * 優先序：購買區配搭 > 同系列 > 相似款式 > 最近看過；全部一起去重；每段最多 4 件；某一段去重後不足門檻整段隱藏（門檻讀根元素 data-cs-p02-min：產品頁 2、系列頁 2，兩邊都是 2；產品頁 2＝店主選定 B3，2026-10-17 架構師工單寫成 4 是錯誤，2026-10-22 r42 改回；讀不到預設 2）；所有段都隱藏時整區隱藏。
 * 去重以卡片主連結的 /products/<handle>（decodeURIComponent 後、轉小寫）辨認，不靠 li 上的屬性。
 * 被隱藏的段落不佔用去重名額（它的商品沒有顯示，不該擋掉優先序較低的段落）。
 *
 * 第七輪（審查 M-B1）：段數要穩定。原本的做法是「哪個來源先到就先去重、先顯示」：
 *   同系列（伺服器印好）馬上套用；相似款式（/recommendations 的非同步請求）和最近看過（/search 的非同步請求）各自回來各自套用，
 *   而且原本是捲到附近才開始請求（IntersectionObserver）。所以取樣時間點不同、或推薦 API 兩次回傳的名單不同，同一頁就會看到 2、3、2 段。
 *   現在：整區預設 is-pending（CSS 隱藏）；一進頁就同時請求相似款式與最近看過，三個來源（同系列、相似、最近）全部到齊（或 6 秒逾時）後，
 *   一次依優先序去重、一次顯示，才拿掉 is-pending。推薦名單（過濾掉不同類別後的商品 id）另外存 localStorage（cs-p02:sim:<商品 id>，30 分鐘），
 *   同一個瀏覽器短時間內重進同一頁，用同一份名單，不會因為推薦 API 回傳不同而換段。
*
 * 第八輪（Codex 第 9 至 14 條）：
 *   各來源分開逾時：相似款式、最近看過各自 6 秒逾時（settle），Promise.allSettled 全部 settled（成功、失敗或逾時）之後才一次去重、一次顯示。
 *   顯示之後晚到的結果一律丟棄、不重排（來源函式只回傳卡片陣列，由 finish 一次放進各段；逾時的來源在 finish 時就是空的）。
 *   JS 失敗不藏卡：伺服器輸出的卡預設可見；init 一啟動才在根元素加 is-pending（CSS 在 is-pending 時隱藏），finish 的 finally 一定拿掉；
 *   JS 檔載入失敗或根本沒跑，根元素沒有 is-pending，卡照樣看得到。
 *   無 JS 時：伺服器端所有段都沒有卡就整區 hidden（連標題與米色框都不輸出）；有卡的段（系列頁的相似款式、產品頁的同系列）照常顯示，沒有與商品格去重（已知、接受，只記錄）。
 *   最近看過：search 請求失敗（reject）或回空，都走 /products/<handle>.js 備援。
*
 * 第十輪（審查 R2-M3，coffee-grinder 頁「最近看過」不出現）：原因＝去重優先序。最近看過排在相似款式之後，9barista-espresso-machine 先被相似款式段取走，
 *   kalita-咖啡清潔掃售罄被伺服器濾掉，最近看過只剩 kalita-紅色格紋布 1 件，低於 2 件門檻，整段 hidden（卡被清空）。現在最近看過被擠到不足時會優先於相似款式（見 applyAll）。
 * 所有段只取有貨商品：伺服器端卡片已濾掉缺貨（recommendations、search、同系列、系列頁相似款式都是）；/products/<h>.js 備援卡用 available 判斷。
 * 每段標題旁的「N 件」是去重後實際顯示的數量（data-t-n 是翻好的字串）。
 * 產品頁：讀頁面上 data-cs-p02-pair-handles（購買區配搭）＋當頁商品＋伺服器端印好的「同系列」卡，建 Set；
 *   相似款式：/recommendations/products?product_id=…&limit=10&intent=related&section_id=<本 section id>，由本 section 在 recommendations 情境輸出卡片；
 *   最近看過：localStorage 鍵 beyours:recently-viewed（主題 global.js 的 product-recently-viewed 寫入，格式是商品 id 的 JSON 陣列，最新在前，最多 5 個），
 *     用 /search?type=product&q=id:… OR id:…&section_id=<本 section id> 取卡；取不到卡片時，改用 /products/<handle>.js 自己組簡易卡
 *     （handle 來自本檔自己記的 cs-p02:recent，所以備援只涵蓋 p02 上線之後逛過的商品）。
 * 系列頁（data-context="collection"）：兩段。相似款式由伺服器依頁首選單的姊妹系列印好（見 section 註解），最近看過同上；
 *   兩段都排除本頁商品格（.cs-p02__item）上的所有商品，商品格換格（cs-p02:swap）後重新去重。
 */
(function () {
  'use strict';
  if (window.__csP02Continue) { return; }
  window.__csP02Continue = true;

  var MAX = 4;
  /* 2026-10-17 r35：段落門檻依頁型，由 section 在根元素輸出 data-cs-p02-min（現在兩邊都是 2：產品頁 2＝店主選定 B3，2026-10-17 架構師工單寫成 4 是錯誤，2026-10-22 r42 改回；系列頁 2＝舊行為）。
     讀不到或不是正整數時預設 2（系列頁舊行為，保守）。minOf 每次呼叫現讀，不快取。 */
  var MIN_DEFAULT = 2;
  function minOf(el) {
    var host = el && el.closest ? el.closest('[data-cs-p02-continue]') : null;
    var n = host ? parseInt(host.getAttribute('data-cs-p02-min'), 10) : NaN;
    return n > 0 ? n : MIN_DEFAULT;
  }
  var RV_KEY = 'beyours:recently-viewed';
  var OWN_KEY = 'cs-p02:recent';
  var SRC_TIMEOUT = 6000;

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function handleOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) { return ''; }
    var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if (!m) { return ''; }
    var h = m[1];
    try { h = decodeURIComponent(h); } catch (e) { /* 保持原樣 */ }
    return h.toLowerCase();
  }

  function normHandle(h) {
    h = String(h || '');
    try { h = decodeURIComponent(h); } catch (e) { /* 保持原樣 */ }
    return h.toLowerCase();
  }

  function store(key) {
    try { return JSON.parse(window.localStorage.getItem(key) || '[]'); } catch (e) { return []; }
  }

  /* 對一段套用去重：留下沒出現在 seen 的前 MAX 件；不足 minOf(seg) 件就整段隱藏（而且不把它的商品記進 seen）。回傳是否顯示。
     候選卡第一次進來時整批記在 seg._csCands，之後每次都從候選重算（不是從剩下的卡重算），
     所以系列頁換格後，先前因為出現在商品格而被排除的商品，之後不在商品格時可以回來。 */
  function setCount(seg, n) {
    var el = q('[data-cs-p02-n]', seg);
    if (!el) { return; }
    var tpl = (seg.closest('[data-cs-p02-continue]') || document.body).getAttribute('data-t-n') || '';
    var text = n > 0 && tpl ? tpl.replace('__N__', String(n)) : '';
    if (el.textContent !== text) { el.textContent = text; }   // 一樣就不寫（寫了會重建文字節點，白白觸發 DOM 變動）
  }

  /* 第三十一輪審查修正（Codex：swap 時的生命週期副作用）：把「算出結果」和「寫進畫面」分開。
     plan 只算（讀候選、讀 seen、把顯示的商品記進 seen），不碰 DOM；commit 才寫，而且寫之前先和畫面上現有的卡比較：
       - 同一個節點已經在畫面上、位置也對 → 不 detach、不重新 append（重新接上會讓 <quick-view> 的 connectedCallback 再跑一次，
         每次新增一個永遠不會 disconnect 的 IntersectionObserver，之後開快速預覽可能重複請求 modal；assets/quick-view.js:51）
       - 只移除變成重複（或超過上限）的卡，再補上新卡；結果完全相同時什麼都不做
     畫面上的卡永遠是候選（seg._csCands）的子序列、順序與候選相同，所以補新卡只需要插在「下一張留下的卡」之前，留下的卡不會被搬動。 */
  function plan(seg, seen) {
    var ul = q('ul', seg);
    if (!seg._csCands) { seg._csCands = qa(':scope > li', ul); }
    var local = Object.create(null);   // 不用 {}：handle 叫 constructor／toString 的商品會被當成「已經有了」
    var kept = [];
    seg._csCands.forEach(function (li) {
      var h = handleOf(li);
      if (!h || seen[h] || local[h]) { return; }
      local[h] = true;
      kept.push({ li: li, h: h });
    });
    kept = kept.slice(0, MAX);
    if (kept.length < minOf(seg)) { return { seg: seg, ul: ul, kept: [], show: false }; }
    kept.forEach(function (k) { seen[k.h] = true; });
    return { seg: seg, ul: ul, kept: kept, show: true };
  }

  /* 已知殘留（Codex 複審 (a)，店主側裁定接受、不修）：卡被去重移除、之後又恢復時，同一個節點會重新接回 DOM，<quick-view> 的 connectedCallback 又建一個 IntersectionObserver
     而且從不 disconnect——這是原生 assets/quick-view.js 的行為，P-02 不能改那支檔。這裡只做到「沒有變動的卡不 detach、不重新 append」，把累積壓到最低；真的被移除再放回的卡仍會多一個。 */
  function commit(p) {
    var ul = p.ul;
    var want = p.kept.map(function (k) { return k.li; });
    Array.prototype.slice.call(ul.children).forEach(function (li) {
      if (want.indexOf(li) < 0) { ul.removeChild(li); }
    });
    want.forEach(function (li, i) {
      if (ul.children[i] !== li) { ul.insertBefore(li, ul.children[i] || null); }
    });
    if (p.seg.hidden === p.show) { p.seg.hidden = !p.show; }
    setCount(p.seg, p.kept.length);
  }

  function refreshRoot(root) {
    var top = root.closest('[data-cs-p02-continue-root]');
    if (!top) { return; }
    var first = true;
    qa('[data-cs-p02-seg]', root).forEach(function (seg) {
      if (!seg.hidden && first) { if (!seg.hasAttribute('data-first')) { seg.setAttribute('data-first', ''); } first = false; }
      else if (seg.hasAttribute('data-first')) { seg.removeAttribute('data-first'); }
    });
    if (top.hidden !== first) { top.hidden = first; } // first 還是 true＝沒有任何一段顯示
  }

  function fetchDoc(url) {
    return window.fetch(url, { credentials: 'same-origin' }).then(function (r) {
      return r.ok ? r.text() : '';
    }).then(function (t) {
      return t ? new DOMParser().parseFromString(t, 'text/html') : null;
    });
  }

  function adoptItems(doc, sel, into) {
    if (!doc) { return 0; }
    var items = qa(sel, doc);
    items.forEach(function (li) { into.appendChild(document.importNode(li, true)); });
    return items.length;
  }

  function buildSimple(json) {
    var li = document.createElement('li');
    li.className = 'cs-p02-cont__item cs-p02-cont__simple';
    li.setAttribute('data-product-id', String(json.id));
    var a = document.createElement('a');
    a.href = json.url || ('/products/' + json.handle);
    if (json.featured_image) {
      var img = document.createElement('img');
      img.src = json.featured_image;
      img.alt = '';
      img.loading = 'lazy';
      a.appendChild(img);
    }
    var t = document.createElement('span');
    t.className = 'cs-p02-cont__st';
    t.textContent = json.title || '';
    a.appendChild(t);
    var p = document.createElement('span');
    p.className = 'cs-p02-cont__sp';
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'HKD';
    try {
      // r41 T07：非整元顯示到小數兩位（同 r40 F5 價錢 chip），12.50 不再四捨五入成 HK$13；變價照同一排伺服器卡（card-product 的 cs_v8_zh：語系含 zh 印「起」、其他印「+」）
      var digits = ((json.price || 0) % 100 === 0) ? 0 : 2;
      p.textContent = new Intl.NumberFormat(document.documentElement.lang || 'zh-HK', { style: 'currency', currency: cur, minimumFractionDigits: digits, maximumFractionDigits: digits }).format((json.price || 0) / 100);
      if (json.price_varies) { p.textContent += /zh/i.test(document.documentElement.lang || '') ? ' 起' : ' +'; }
    } catch (e) {
      p.textContent = String((json.price || 0) / 100);
    }
    a.appendChild(p);
    li.appendChild(a);
    return li;
  }

  function searchUrl(root, ids) {
    return root.getAttribute('data-search-url') + '?type=product&q=' + encodeURIComponent(ids.map(function (i) { return 'id:' + i; }).join(' OR ')) +
      '&section_id=' + encodeURIComponent(root.getAttribute('data-section-id'));
  }

  /* 用商品 id 清單向本 section 的 search 情境要卡片（伺服器端已濾掉缺貨與 Sharing Cup），依 ids 順序排 */
  function fetchCardsByIds(root, ids) {
    return fetchDoc(searchUrl(root, ids)).then(function (doc) {
      var lis = doc ? qa('[data-cs-p02-search] .cs-p02-cont__item', doc) : [];
      lis.sort(function (a, b) {
        return ids.indexOf(parseInt(a.getAttribute('data-product-id'), 10)) - ids.indexOf(parseInt(b.getAttribute('data-product-id'), 10));
      });
      return lis;
    });
  }

  /* Sharing Cup 的 id 清單：伺服器端印在 section 根元素 data-cs-p02-sc-ids（前後各一個逗號的字串）。取不到或空 → 回空陣列（只剩 handle 後備） */
  function scIdsOf(root) {
    try {
      var top = root.closest('[data-cs-p02-continue-root]');
      var raw = top ? (top.getAttribute('data-cs-p02-sc-ids') || '') : '';
      return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    } catch (e) { return []; }
  }
  /* 回傳比對方式（'id' 或 'handle'），沒比對到回 ''。id 用整串相等，不用子字串 */
  function scMatch(ids, json, own) {
    if (ids.indexOf(String(json.id)) >= 0) { return 'id'; }
    var key = 'coffee-stage-sharing-cup';
    if (String(json.handle || '').indexOf(key) >= 0 || String((own && own.handle) || '').indexOf(key) >= 0) { return 'handle'; }
    return '';
  }

  /* 取得最近看過的卡（回傳卡片陣列；不放進頁面，由 finish 一次放）。search 失敗或回空都走 /products/<handle>.js 備援 */
  function loadRecent(root, curPid) {
    var ids = store(RV_KEY).map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0 && String(x) !== String(curPid); }).slice(0, 8);
    if (!ids.length) { return Promise.resolve([]); }
    return fetchCardsByIds(root, ids).catch(function () { return []; }).then(function (lis) {
      if (lis.length) { return lis; }
      // 備援：section rendering 在 search 情境取不到卡片（或請求失敗），改用 /products/<handle>.js 自己組（缺貨的不收）
      var own = store(OWN_KEY);
      var pairs = ids.map(function (id) { return own.filter(function (o) { return String(o.id) === String(id); })[0]; }).filter(Boolean);
      var scIds = scIdsOf(root);
      var skipped = [];
      return Promise.all(pairs.map(function (o) {
        return window.fetch(root.getAttribute('data-root-url').replace(/\/$/, '') + '/products/' + encodeURIComponent(o.handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (list) {
        // 第二十輪後半：備援路自己組卡，沒有伺服器端的 Sharing Cup 過濾，所以這裡補。
        // 認法：回應的 id 在 section 根元素印出的 id 清單裡（外語頁 handle 會被翻譯，只比 handle 認不出），或 handle（回應的、請求的）含 coffee-stage-sharing-cup（後備）。
        // 清單與 cs-p02-pairing／cs-p02-continue／cs-p02-card 的 cs_sc_ids 同一組；屬性不存在或空就只剩 handle 後備，不丟例外。
        var kept = list.filter(function (j, i) {
          if (!j || j.available === false) { return false; }
          var hit = scMatch(scIds, j, pairs[i]);
          if (hit) { skipped.push(String(j.id) + ':' + hit); return false; }
          return true;
        });
        // A-6 記號：印「排除了誰、用什麼比對到」，不印「有沒有」；沒有排除就不寫（不洗版、不用 console）
        if (skipped.length) { root.setAttribute('data-cs-p02-sc-skip', skipped.join(',')); }
        return kept.map(buildSimple);
      });
    });
  }

  var SIM_TTL = 30 * 60 * 1000;
  function simCacheKey(pid) { return 'cs-p02:sim:' + pid; }
  function readSim(pid) {
    try {
      var o = JSON.parse(window.localStorage.getItem(simCacheKey(pid)) || 'null');
      if (o && o.t && Date.now() - o.t < SIM_TTL && o.ids && o.ids.length) { return o.ids; }
    } catch (e) { /* 略過 */ }
    return null;
  }
  function writeSim(pid, ids) {
    try { window.localStorage.setItem(simCacheKey(pid), JSON.stringify({ t: Date.now(), ids: ids })); } catch (e) { /* 略過 */ }
  }

  /* 取得相似款式的卡（回傳卡片陣列；不放進頁面） */
  function loadSimilar(root, pid) {
    var fromRecs = function () {
      var url = root.getAttribute('data-rec-url') + '?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related&section_id=' + encodeURIComponent(root.getAttribute('data-section-id'));
      return fetchDoc(url).then(function (doc) {
        var lis = doc ? qa('[data-cs-p02-rec] .cs-p02-cont__item', doc) : [];
        var ids = lis.map(function (li) { return parseInt(li.getAttribute('data-product-id'), 10); }).filter(function (x) { return x > 0; });
        if (ids.length) { writeSim(pid, ids); }
        return lis;
      });
    };
    var cached = readSim(pid);
    if (!cached) { return fromRecs(); }
    return fetchCardsByIds(root, cached).catch(function () { return []; }).then(function (lis) { return lis.length ? lis : fromRecs(); });
  }

  /* 單一來源的逾時：ms 內沒回來就當成空（回 null），之後才回來的結果沒有人會讀（晚到一律丟棄） */
  function settle(p, ms) {
    return new Promise(function (resolve) {
      var done = false;
      var t = window.setTimeout(function () { if (!done) { done = true; resolve(null); } }, ms);
      Promise.resolve(p).then(function (v) {
        if (!done) { done = true; window.clearTimeout(t); resolve(v); }
      }, function () {
        if (!done) { done = true; window.clearTimeout(t); resolve(null); }
      });
    });
  }

  function rememberCurrent(root) {
    var id = root.getAttribute('data-product-id');
    var handle = root.getAttribute('data-product-handle');
    if (!id || !handle) { return; }
    try {
      var own = store(OWN_KEY).filter(function (o) { return String(o.id) !== String(id); });
      own.unshift({ id: id, handle: handle });
      window.localStorage.setItem(OWN_KEY, JSON.stringify(own.slice(0, 10)));
    } catch (e) { /* localStorage 不可用：略過 */ }
  }

  /* 系列頁：目前商品格上所有商品都算已出現 */
  function collectGridSeen(seen) {
    qa('.cs-p02__item').forEach(function (li) {
      var h = handleOf(li) || normHandle(li.getAttribute('data-handle'));
      if (h) { seen[h] = true; }
    });
  }

  /* 重建 seen（購買區配搭、當頁商品或商品格）。seen 每次重建，所以可以重複呼叫（換格後、改順序重算） */
  function seedSeen(root) {
    var ctx = root.getAttribute('data-context');
    var seen = root._csSeen;
    Object.keys(seen).forEach(function (k) { delete seen[k]; });
    if (ctx === 'product') {
      seen[normHandle(root.getAttribute('data-product-handle'))] = true;
      qa('[data-cs-p02-pair-handles]').forEach(function (el) {
        (el.getAttribute('data-cs-p02-pair-handles') || '').split(',').forEach(function (h) { if (h) { seen[normHandle(h)] = true; } });
      });
    } else {
      collectGridSeen(seen);
    }
    return seen;
  }
  /* 只算不寫：回傳 { 段名: plan }（見上面 plan／commit） */
  function runOrder(root, order) {
    var seen = seedSeen(root);
    var plans = {};
    order.forEach(function (name) {
      var seg = q('[data-cs-p02-seg="' + name + '"]', root);
      if (seg) { plans[name] = plan(seg, seen); }
    });
    return plans;
  }

  /* 依優先序去重並顯示：購買區配搭（已在 seen）> 同系列 > 相似款式 > 最近看過。
     第十輪（R2-M3）：最近看過是客人自己的瀏覽紀錄。原本它排最後，商品被相似款式先取走之後只剩 1 件（不足 2 件）就整段隱藏，
     客人明明看過 2 件有貨的卻看不到這一段。現在：照原順序算完，如果最近看過被隱藏、但它的候選（售罄已由伺服器濾掉）有 2 件以上，
     就改成「同系列 > 最近看過 > 相似款式」再算一次；最近看過因此顯示就保留這個結果（相似款式可能因此不足 2 件而隱藏），沒有救回就照原順序。 */
  function applyAll(root) {
    // 第三十一輪審查修正：兩種順序都只「算」，挑定結果之後才 commit 一次（原本每種順序都會先清空再接回，中間狀態每次 swap 都重來一遍）
    var plans = runOrder(root, ['series', 'similar', 'recent']);
    var recent = q('[data-cs-p02-seg="recent"]', root);
    var priority = false;
    if (recent && plans.recent && !plans.recent.show && recent._csCands && recent._csCands.length >= minOf(recent)) {
      var alt = runOrder(root, ['series', 'recent', 'similar']);
      if (alt.recent && alt.recent.show) { plans = alt; priority = true; }
    }
    Object.keys(plans).forEach(function (name) { commit(plans[name]); });
    if (priority !== root.hasAttribute('data-recent-priority')) {
      if (priority) { root.setAttribute('data-recent-priority', ''); } else { root.removeAttribute('data-recent-priority'); }
    }
    refreshRoot(root);
  }

  /* 系列頁換格（cs-p02-collection.js 換完 grid 之後送 cs-p02:swap）：來源都到齊之後才重新去重（沒到齊時，到齊那一刻本來就會用新的商品格） */
  function onSwap() {
    qa('[data-cs-p02-continue][data-context="collection"]').forEach(function (root) {
      if (root._csReady) { applyAll(root); }
    });
  }
  document.addEventListener('cs-p02:swap', onSwap);

  function init(root) {
    if (root._csInit) { return; }
    root._csInit = true;
    var top = root.closest('[data-cs-p02-continue-root]');
    // JS 跑起來才加 is-pending（CSS 隱藏）；JS 沒載入或沒跑，根元素沒有這個 class，伺服器印好的卡照樣看得到
    if (top) { top.classList.add('is-pending'); }
    var release = function () { if (top) { top.classList.remove('is-pending'); } };
    try {
      var ctx = root.getAttribute('data-context');
      root._csSeen = Object.create(null);   // 同 plan() 的 local：不用 {}，handle 叫 constructor 的商品才不會被當成已出現
      var pid = root.getAttribute('data-product-id');
      if (ctx === 'product') { rememberCurrent(root); }

      // 來源：相似款式（產品頁）、最近看過。各自 6 秒逾時；同系列是伺服器印好的，不用等
      var jobs = [];
      var similar = q('[data-cs-p02-seg="similar"]', root);
      if (ctx === 'product' && similar && pid) { jobs.push({ seg: similar, p: settle(loadSimilar(root, pid), SRC_TIMEOUT) }); }
      var recent = q('[data-cs-p02-seg="recent"]', root);
      if (recent) { jobs.push({ seg: recent, p: settle(loadRecent(root, ctx === 'product' ? pid : ''), SRC_TIMEOUT) }); }

      Promise.allSettled(jobs.map(function (j) { return j.p; })).then(function (results) {
        try {
          // 全部 settled 之後，一次放卡、一次去重、一次顯示；這之後晚到的結果沒有人讀，不會重排
          results.forEach(function (r, i) {
            var seg = jobs[i].seg;
            var ul = q('ul', seg);
            var lis = (r.status === 'fulfilled' && r.value) || [];
            lis.forEach(function (li) { ul.appendChild(document.importNode(li, true)); });
            seg._csCands = qa(':scope > li', ul);
          });
          root._csReady = true;
          applyAll(root);
          root.setAttribute('data-state', 'ready');
        } finally { release(); }
      }).catch(release);
    } catch (e) { release(); }
  }

  function start() { qa('[data-cs-p02-continue]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
